'use client';

import Script from 'next/script';
import { usePathname } from 'next/navigation';
import { MARKETING_CONFIG } from '@/lib/marketing-config';

export function MetaPixel() {
  // The signing link carries a secret token in its path; never hand it to a tracker.
  const pathname = usePathname();
  if (pathname?.startsWith('/firmar/')) return null;

  const pixelId = MARKETING_CONFIG.analytics.metaPixelId;

  // Don't render if Pixel ID is not configured
  if (!pixelId || pixelId === 'XXXXXXXXXXXXXXXX') {
    return null;
  }

  return (
    <>
      {/* Meta Pixel Code */}
      <Script id="meta-pixel" strategy="afterInteractive">
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${pixelId}');
          fbq('track', 'PageView');
        `}
      </Script>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
          alt=""
        />
      </noscript>
    </>
  );
}

/**
 * Helper function to track custom events
 * Usage in components:
 *
 * import { trackMetaEvent } from '@/components/analytics/MetaPixel';
 * trackMetaEvent('Lead', { source: 'hero', value: 35 });
 */
export function trackMetaEvent(
  eventName: string,
  eventParams?: Record<string, any>
) {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    (window as any).fbq('track', eventName, eventParams);
  }
}

/**
 * Common Meta Pixel Standard Events:
 *
 * - PageView: Already tracked on load
 * - ViewContent: User views landing page section
 * - Lead: User clicks CTA / opens WhatsApp
 * - InitiateCheckout: User clicks pricing CTA
 * - CompleteRegistration: User signs up (future)
 */

export const MetaEvents = {
  ViewContent: 'ViewContent',
  Lead: 'Lead',
  InitiateCheckout: 'InitiateCheckout',
  CompleteRegistration: 'CompleteRegistration',
  Contact: 'Contact',
} as const;
